import * as stylex from "@stylexjs/stylex";
import "@/theme/tokens.stylex";
import { colors, radii, space } from "@/theme/tokens.stylex";
import "@/theme/type.stylex";
import { type } from "@/theme/type.stylex";
import { Slider } from "@/ui/Slider";
import { Switch } from "@/ui/Switch";
type TileText = {
  title: string;
  value: (value: number) => string;
  on: string;
  off: string;
  slider: string;
};
type SwitchSliderTileProps = {
  text: TileText;
  range: {
    min: number;
    max: number;
  };
  on: boolean;
  value: number;
  onChange: (on: boolean, value: number) => void;
};
const styles = {
  header: {
    kzqmXN: "xh8yej3",
    kjj79g: "x1qughib",
    $$css: true
  }
};
export function SwitchSliderTile({
  text,
  range,
  on,
  value,
  onChange
}: SwitchSliderTileProps) {
  return <div className="x78zum5 xdt5ytf x152posx">
      <Switch label={text.title} checked={on} onChange={checked => onChange(checked, value)} labelStyle="eyebrow" xstyle={styles.header} />
      <div className="x78zum5 xdt5ytf x17d4w8g xh540kj x1fv5t7x x1xckggx x17qtykl">
        <div className="x78zum5 x1pha0wt x152posx">
          <span {...{
          0: {
            className: "xneq65o x1v94iar xrg9stw xss6m8b"
          },
          1: {
            className: "xneq65o x1v94iar xrg9stw xss6m8b xmqliwb"
          }
        }[!!!on << 0]}>{text.value(value)}</span>
          <span className="x14c3fy2 x1dld7ex">{on ? text.on : text.off}</span>
        </div>
        <Slider label={text.slider} min={range.min} max={range.max} value={value} valueText={text.value(value)} minLabel={text.value(range.min)} maxLabel={text.value(range.max)} onChange={next => onChange(true, next)} disabled={!on} />
      </div>
    </div>;
}